import { call, put, takeLatest } from 'redux-saga/effects';
import constants from './constants.js';
import reduce from 'lodash/reduce';
import actions from './actions.js';
import request from './request.js';

const getHeader = {
	method: 'GET',
	headers: {
		'Content-Type': 'application/json'
	}
};
const postHeader = {
	method: 'POST',
	headers: {
		Accept: 'application/json', // eslint-disable-line no-console
		'Content-Type': 'application/json' // eslint-disable-line no-console
	}
};
const putHeader = {
	method: 'PUT'
};
const deleteHeader = {
	method: 'DELETE'
};

function* manageHttp(object) {
	try {
		let opt = {};

		// carico tutti i body params
		const options = JSON.stringify(
			object.bodyParams
				? reduce(
					object.bodyParams,
					(accumulator, bodyParam) => {
						accumulator[ bodyParam ] = object.params[ bodyParam ];
						return accumulator;
					},
					{}
				  )
				: { a: '_' }
		);

		let formData = new FormData();
		let objectOptions = JSON.parse(options);

		for (let key in objectOptions) {
			formData.append(key, objectOptions[ key ]);
		}

		// in base al metodo valorizzo i body params
		switch (object.method) {
		case 'post':
			opt = postHeader;
			opt.body = options; // formData

			if (object.tokenRequired) {
				opt.headers = {
					...postHeader.headers,
					Authorization: 'Bearer token'
				};
			}

			break;
		case 'put':
			opt = putHeader;
			opt.body = formData;

			if (object.tokenRequired) {
				opt.headers = {
					Authorization: 'Bearer token'
				};
			}

			break;
		case 'delete':
			opt = deleteHeader;
			opt.body = formData;

			if (object.tokenRequired) {
				opt.headers = {
					Authorization: 'Bearer token'
				};
			}

			break;
		default:
			opt = getHeader;
			opt.args = formData;

			if (object.tokenRequired) {
				opt.headers = {
					...getHeader.headers,
					Authorization: 'Bearer token'
				};
			}

			break;
		}

		//valorizzo i restParams
		object.url.match(/({[A-z0-9]+})/g).forEach(param => {
			object.url = object.url.replace(
				param,
				object.params[ param.replace('{', '').replace('}', '') ]
			);
		});

		// valorizzo i query params
		let queryUrl = object.queryParams
			? reduce(
				object.queryParams,
				(accumulator, queryParam, index) => {
					const prefix = index === 0 ? '' : '&';
					if (object.params[ queryParam ]) {
						const param = `${prefix}${queryParam}=${
							object.params[ queryParam ]
						}`;
						return `${accumulator}${param}`;
					}
					return `${accumulator}`;
				},
				'?'
			  )
			: '';

		if (object.showLog) {
			console.log(
				`[SAGA] sto richiamando questa url: ${object.url}${queryUrl}`
			);
			console.log(opt);
		}

		const values = yield call(request, `${object.url}${queryUrl}`, opt);

		if (constants.mockapi) {
			console.log(values);
			//const returnMock = { error: undefined, response: values };
			object.callback.then && object.callback.then(values);
			yield put(actions[ object.success ](values));

			return;
		}

		if (object.showLog) {
			console.log(
				`[SAGA] la risposta della chiamta alla url ${object.url}
				${queryUrl} è:\n${JSON.stringify(values)}`
			);
		}

		if (values.error != null) {
			object.callback.catch && object.callback.catch(values.error);
			yield put(actions[ object.error ](values.error));
		} else {
			object.callback.then && object.callback.then(values);
			yield put(actions[ object.success ](values));
		}
	} catch (err) {
		console.log(err);
		if (object.showLog) {
			console.log(`[SAGA] è andata in errore:\n${JSON.stringify(err)}`);
		}
		object.callback.catch && object.callback.catch(err);
		yield put(actions[ object.error ](err));
	}
}

export default function* root() {
	yield constants.actionsData.map(object => {
		return takeLatest(constants[ `LOAD_${object.id.toUpperCase()}` ], manageHttp);
	});
}



// WEBPACK FOOTER //
// ./src/libraries/reducers/http-request/saga.js